import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import { Message } from "react-message-context";
import { focusAtElement, hideOpFiTemplateTitle } from "../../utils/commonUtils";
import { AnimCheck } from "@op/opds.opux";
import ActionByCustomerType from "../ActionByCustomerType";
import { ANALYTICS_EVENTS } from "../../utils/enums";

const ThanksPage = observer(({ RestStore, AnalyticsStore }) => {
  const { feedbackId } = RestStore;

  useEffect(() => {
    hideOpFiTemplateTitle();
    focusAtElement(".cff-thanks__title");
    window.disableLinkInterruption();
    AnalyticsStore.sendPhaseEvent(ANALYTICS_EVENTS.end);
  });

  if (!feedbackId) {
    return <Redirect to="/" />;
  }

  return (
    <div className="cff-thanks">
      <AnimCheck />
      <h1 className="cff-thanks__title" tabIndex={-1}>
        <Message id="thanks.title" />
      </h1>

      <p className="cff-thanks__body">
        <Message id="thanks.body" />
      </p>

      <p className="cff-thanks__body">
        <Message id="thanks.feedbackId" feedbackId={RestStore.feedbackId} />
      </p>

      <ActionByCustomerType
        text="thanks.link"
        url="url.opfi"
        className="cff-thanks__link"
      />
    </div>
  );
});

export default inject("RestStore", "AnalyticsStore")(ThanksPage);
